import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CategoryFormLayer from "../components/CategoryFormLayer";

const CategoryFormPage = () => {
    return (
        <MasterLayout>
            <CategoryFormLayer />
        </MasterLayout>
    );
};

export default CategoryFormPage;
